import { Button } from "@mui/material";
import React from "react";
import SelectModeBanner from "../SelectModeBanner";

import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import { ModalContext } from "../../Modals";
import ModalUsersChangeGroup, {
  ModalUsersChangeGroupElementProps,
  ModalUsersChangeGroupProps,
} from "../../Modals/ModalUsersChangeGroup/modal-users-change-group";
import ModalUsersManageExceptions, {
  ModalUsersManageExceptionsElementProps,
  ModalUsersManageExceptionsProps,
} from "../../Modals/ModalUsersManageExceptions";
import ModalGroupsChangeRole, {
  ModalGroupsChangeRoleElementProps,
  ModalGroupsChangeRoleProps,
} from "../../Modals/ModalGroupsChangeRole/modal-group-change-role";
import { useTranslation } from "react-i18next";

export interface SettingsUsersSelectModeBannerProps {
  handleCloseClick: React.MouseEventHandler;
  selection: number[];
  context: "user" | "roles-and-permissions" | string;
}

const SettingsUsersSelectModeBanner: React.FC<SettingsUsersSelectModeBannerProps> = ({
  handleCloseClick,
  selection,
  context,
}) => {
  const { t } = useTranslation();
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const handleClickChangeGroup = () => {
    if (!openModal) {
      return;
    }

    const onClose: ModalUsersChangeGroupProps["onClose"] = (data) => {};

    openModal<ModalUsersChangeGroupElementProps>(ModalUsersChangeGroup, {
      users: selection,
      onClose,
    });
  };

  const handleClickChangeRole = () => {
    if (!openModal) {
      return;
    }

    const onClose: ModalGroupsChangeRoleProps["onClose"] = (data) => {};

    openModal<ModalGroupsChangeRoleElementProps>(ModalGroupsChangeRole, {
      groups: selection,
      onClose,
    });
  };
  return (
    <>
      <SelectModeBanner
        text={
          context === "user"
            ? t("banner:body.userSelected", { count: selection.length })
            : t("banner:body.groupSelected", { count: selection.length })
        }
        onCloseClick={handleCloseClick}
      >
        {context === "user" && (
          <Button variant="white" startIcon={<PeopleAltOutlinedIcon />} onClick={handleClickChangeGroup}>
            {t("button:changeGroup")}
          </Button>
        )}

        {context === "roles-and-permissions" && (
          <Button variant="white" startIcon={<PeopleAltOutlinedIcon />} onClick={handleClickChangeRole}>
            {t("button:changeRole")}
          </Button>
        )}

        {/*<Button variant="white" onClick={handleClickManageExceptions}>
          Manage exceptions
        </Button>*/}
      </SelectModeBanner>
    </>
  );
};

export default SettingsUsersSelectModeBanner;
